import React, { useEffect, useState, useCallback } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaEdit, FaCircle } from "react-icons/fa";
import { toast } from "react-toastify";

import { api } from "../../api";
import { customStyles } from "../../styles/dataTableStyles";
import Swal from "sweetalert2";

const CustomerInfo = ({ addAccess, role }) => {
  const token = useSelector((state) => state.auth.token);
  const navigate = useNavigate();

  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const fetchCustomers = useCallback(async (pageNo, searchKey, pageSize) => {
    try {
      setLoading(true);
      const response = await api.customerInfo.getCustomerList({
        pageNo,
        pageSize,
        sort: "desc",
        sortBy: "createdAt",
        searchKey
      },token);

      if (response.success) {
        setCustomers(response.data.result);
        setTotalRows(response.data.totalCount);

  
      } else {
        setCustomers([]);
        setTotalRows(0);
        //         const staticdata = [
        //     {
        //       "id": 63,
        //       "name": "test002",
        //       "phone": "1234567890",
        //       "email": "test002@dispostable.com",
        //       "address": "Hello World, 123 Street, Bangalore, 560043",
        //       "uniqueCode": "UU3HEE",
        //       "status": true,
        //       "createdAt": "2021-02-22T18:02:02.021Z",
        //       "updatedAt": "2021-03-02T07:40:29.765Z"
        //     },
        //     {
        //       "id": 62,
        //       "name": "test001",
        //       "phone": "0123456789",
        //       "email": "test001@gmail.com",
        //       "address": "qwerty",
        //       "uniqueCode": "FT45E6",
        //       "status": true,
        //       "createdAt": "2021-02-22T18:00:46.419Z",
        //       "updatedAt": "2021-02-22T18:00:46.419Z"
        //     },
    

        //     ];

            
        //  setCustomers(staticdata);
        //  setTotalRows(2);
      }
    } catch (error) {
      console.error("Error fetching customer info", error);
    } finally {
      setLoading(false);
    }
  }, [token]);

   useEffect(() => {
        setPage(1);
      // eslint-disable-next-line
    }, [search]);

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      fetchCustomers(page, search, pageSize);
    }, 500);
    return () => clearTimeout(delaySearch);
  }, [page, search, pageSize, fetchCustomers]);

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to inactive this customer?",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "rgb(112 110 115)",
      confirmButtonText: "Okay",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.customerInfo.deleteCustomerInfo({ delete_array: [id], status: false });
          toast.success("Profile deactivated successfully");
          fetchCustomers(page, search, pageSize);
        } catch {
          toast.error("Something went wrong");
        }
      }
    });
  };

  const handleActivate = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to activate this merchant?",
      showCancelButton: true,
      confirmButtonColor: "rgb(68, 170, 68)",
      cancelButtonColor: "rgb(112 110 115)",
      confirmButtonText: "Activate",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.customerInfo.deleteCustomerInfo({ delete_array: [id], status: true });
          toast.success("Profile activated successfully");
          fetchCustomers(page, search, pageSize);
        } catch {
          toast.error("Something went wrong");
        }
      }
    });
  };

  const columns = [
    { name: "ID", selector: row => row.id, sortable: true, width: "80px" },
    { name: "Name", selector: row => row.name, sortable: true},
    { name: "Phone", selector: row => row.phone || "-"},
    { name: "Address", selector: row => row.address || "-" },
    { name: "Email", selector: row => row.email || "-" , width: "200px" },
    { name: "Unique Code", selector: row => row.uniqueCode},
    {
      name: "Status",
      selector: row => (row.status ? "Active" : "Inactive"),
      cell: row => (
        <span
          style={{
            padding: "5px 10px",
            borderRadius: "5px",
            color: row.status ? "#44aa44" : "#ff4b4b",
            display: "inline-block",
            minWidth: "80px",
            textAlign: "center",
          }}
        >
          {row.status ? "Active" : "Inactive"}
        </span>
      ),
      width: "100px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
          {row.status ? (
            <>
              <button className="btn btn-primary btn-sm" onClick={() => navigate(`/customer-info-view/${row.id}`)}>View</button>
           
                <>
                  <button className="listButton" onClick={() => navigate(`/customer-info-edit/${row.id}`)}><FaEdit /></button>
                  <button title="Click to Inactive" className="listButton" onClick={() => handleDelete(row.id)}>
                    <FaCircle style={{ fill: 'green' }} />
                    </button>
                </>
             
            </>
          ) : (
           
              <button title="Click to Active" className="listButton" style={{ minWidth: "80px" }} onClick={() => handleActivate(row.id)}>
                <FaCircle style={{ fill: 'grey' }} />
              </button>
           
          )}
        </div>
      ),
      ignoreRowClick: true,

      width: "200px",
    },
  ];

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="sec-header">CUSTOMER INFO</h2>
        <div className="d-flex align-items-center">
          <label className="mr-2">Search:</label>
          <input
            type="text"
            placeholder="Customer Name"
            className="form-control"
            style={{ width: "200px" }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <DataTable
        columns={columns}
        data={customers}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangePage={setPage}
        onChangeRowsPerPage={(newPageSize, newPage) => {
          setPageSize(newPageSize);
          setPage(newPage);
        }}
        highlightOnHover
        customStyles={customStyles}
        responsive
        noHeader={false}
        wrap
      />
    </div>
  );
};

export default CustomerInfo;
